var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEaBrandingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "ea-branding-icon_svg__a",
    d: "M0 0h29.125v6.986H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ea-branding-icon_svg__c",
    d: "M0 0h5.654v28.322H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.011)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-branding-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-branding-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.18 6.986L0 5.272A29.818 29.818 0 0116.989 0c4.223 0 8.306.86 12.136 2.556L28.28 4.46A27.73 27.73 0 0016.99 2.082 27.762 27.762 0 001.18 6.986",
    fill: "#E8E9EA",
    mask: "url(#ea-branding-icon_svg__b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.614 42.267A29.782 29.782 0 010 30c0-4.377.922-8.598 2.742-12.546l1.89.872A27.696 27.696 0 002.083 30c0 3.975.818 7.816 2.432 11.415l-1.9.852zM30 60c-4.782 0-9.54-1.153-13.758-3.333l.956-1.852c3.98 2.06 8.289 3.102 12.802 3.102 3.554 0 7.016-.659 10.292-1.958l.767 1.937A29.885 29.885 0 0130 60",
    fill: "#E8E9EA"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.346 16.372)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ea-branding-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ea-branding-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.814 28.322L0 27.302a27.949 27.949 0 003.57-13.674C3.57 9.161 2.549 4.894.533.948L2.387 0c2.168 4.243 3.267 8.828 3.267 13.628 0 5.15-1.328 10.231-3.84 14.694",
    fill: "#E8E9EA",
    mask: "url(#ea-branding-icon_svg__d)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.568 30c0 11.358-9.207 20.565-20.565 20.565-11.359 0-20.566-9.207-20.566-20.565 0-11.359 9.207-20.566 20.566-20.566 11.358 0 20.565 9.207 20.565 20.566",
    fill: "#F8D7CC"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74A10",
    d: "M15.223 11.925l-5.89 5.891 33.87 33.87 5.89-5.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4 17.412l32.802 32.802 4.419-4.419-32.802-32.801-6.627-2.209 2.209 6.627zm32.802 35.315c-.275 0-.541-.11-.736-.305L8.755 18.71a1.04 1.04 0 01-.252-.407L5.558 9.468a1.04 1.04 0 01.252-1.065c.278-.28.691-.378 1.065-.252l8.835 2.946c.153.05.293.136.408.25L49.829 45.06a1.042 1.042 0 010 1.473l-5.89 5.89c-.195.196-.46.305-.737.305z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M45.412 49.476l-33.87-33.869 1.472-1.472 33.87 33.869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.404 56.26c-.67 0-1.32-.22-1.835-.734l-3.103-3.104 1.472-1.473 3.103 3.104c.289.288 1.099.06 1.606-.45l2.946-2.944c.24-.239.445-.446-.132-1.024l-3.105-3.104 1.473-1.472 3.104 3.104c1.264 1.264 1.315 2.784.133 3.968l-2.947 2.945c-.713.714-1.738 1.185-2.715 1.185",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "M47.964 5.394L4.23 49.13l6.248 6.247 43.734-43.734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.702 49.129l4.776 4.775 42.261-42.262-4.775-4.775L5.702 49.129zm4.776 7.72l-7.72-7.72L47.964 3.922l7.72 7.72L10.478 56.85z",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    d: "M46.208 19.393l-2.945-2.945 1.472-1.472 2.945 2.944zM49.89 15.712l-2.946-2.945 1.473-1.472 2.945 2.944zM38.845 26.756L35.9 23.811l1.473-1.472 2.945 2.945zM42.527 23.075l-2.946-2.946 1.472-1.472L44 21.603zM31.482 34.12l-2.945-2.946L30.01 29.7l2.945 2.946zM35.163 30.437l-2.944-2.945 1.472-1.472 2.945 2.945zM24.12 41.482l-2.947-2.945 1.473-1.473 2.946 2.945zM27.8 37.8l-2.945-2.944 1.472-1.473 2.946 2.945zM16.756 48.845L13.81 45.9l1.472-1.472 2.945 2.944zM20.437 45.164l-2.944-2.945 1.472-1.472 2.945 2.944zM12.92 52l-2.735-2.367 1.362-1.576 2.736 2.366z"
  }))));
}
export default SvgEaBrandingIcon;